module.exports = __webpack_public_path__ + "img/01.dc04176f.jpg";